import { PRODUCTION_API_DOMAIN, server } from "./constants";
import moment from 'moment'

export const DATE_FORMATS = {
  long: 'dddd, MMMM D, YYYY',
  short: 'ddd, MMM D, YYYY',
  slash: 'MM/DD/YYYY',
  iso: 'YYYY-MM-DD',
  twelveHour: 'h:mm A',
  twentyFourHour: 'HH:mm',
  longDateWithTime: 'MMM D, YYYY [at] h:mm A',
};

export const isDevMode = !server.includes(PRODUCTION_API_DOMAIN);

export const MIN_DOB = "1920-01-01";

export const getInitials = (name: string): string =>
  (name || '')
    .split(' ')
    .filter((p) => /^[a-zA-Z]/.test(p))
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();

export const stripHTML = (htmlString: string) => {
  return htmlString.replace(/<[^>]*>/g, '');
}

export function filterParams(params = {}) {
  const payload = {};

  Object.keys(params).forEach((key) => {
    payload[key] = typeof params[key] === 'string' && !params[key] ? null : params[key];
  });

  return payload;
}

export function formatDate(date, format = 'iso') {
  return moment(date).format(DATE_FORMATS[format] || format)
}

export function chatDateLabel(date) {
  const value = moment(date)

  if (!value.isValid()) return ''
  if (value.isSame(moment(), 'day')) return 'Today'
  if (value.isSame(moment().subtract(1, 'day'), 'day')) return 'Yesterday'

  return value.format(DATE_FORMATS.short)
}

export function isSameDay(firstDate, secondDate) {
  const first = moment(firstDate)
  const second = moment(secondDate)

  return first.isValid() && second.isValid() && first.isSame(second, 'day')
}

export function timeAgo(timestamp: string) {
  return moment(timestamp).fromNow()
}
